import { saveAction, getAction, streamAction } from "@/utils/store-fns";
import { serverUrl } from "@/utils/env-variables-fns";

export default {
  CREATE_CONVERSATION: (context, payload) => {
    return new Promise((resolve) => {
      saveAction(
        context,
        payload,
        `${serverUrl}/analytics/create-conversation`,
        "CREATE_CONVERSATION"
      ).then((response) => {
        resolve(response);
      });
    });
  },

  GET_METRICS: (context, payload) => {
    return new Promise((resolve) => {
      getAction(
        context,
        `${serverUrl}/analytics/get-metrics`,
        "SET_METRICS",
        payload
      ).then((response) => {
        resolve(response);
      });
    });
  },

  HANDLE_ANALYTICS_MESSAGE: (context, payload) => {
    return new Promise((resolve) => {
      let currentMessage = "";

      streamAction(
        context,
        {
          conversationId: payload.conversationId, // Use the passed conversationId
          message: payload.message,
        },
        `${serverUrl}/analytics/handle-analytics-message`,
        async (data) => {
          try {
            if (data.type === "content") {
              currentMessage += data.content;
              context.commit("UPDATE_STREAMING_MESSAGE", {
                content: currentMessage,
                isComplete: false,
              });
            } else if (data.type === "complete") {
              context.commit("UPDATE_STREAMING_MESSAGE", {
                content: currentMessage,
                isComplete: true,
              });
              if (data.result) {
                context.commit("HANDLE_ANALYTICS_MESSAGE", data.result);
              }
            }
          } catch (error) {
            console.error("Error handling stream data:", error);
          }
        }
      )
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          console.error("Stream error:", error);
          resolve(error);
        });
    });
  },

  GET_CONVERSATION: (context, payload) => {
    return new Promise((resolve, reject) => {
      saveAction(
        context,
        payload,
        `${serverUrl}/analytics/get-conversation`,
        "SET_CONVERSATION"
      )
        .then((response) => {
          if (response === "Success") {
            resolve(response);
          } else {
            // Make sure to reject the promise on error
            reject(new Error(response || "Failed to get conversation"));
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
